import { c as _c } from "react/compiler-runtime";
import React from 'react';
const SettingsMenuSkeleton = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-b-text-secondary/10 border-b px-5 py-2.5"><div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="border-b-text-secondary/10 border-b px-5 py-2.5"><div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="border-b-text-secondary/10 border-b px-5 py-2.5"><div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="border-b-text-secondary/10 border-b px-5 py-2.5"><div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-background-secondary inset-0 flex h-fit w-full animate-pulse flex-col overflow-auto rounded-md last:border-b-transparent lg:w-[250px]">{t0}{t1}{t2}{t3}<div className="border-b-text-secondary/10 border-b px-5 py-2.5"><div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default SettingsMenuSkeleton;